export const USER_LOGIN = 'USER_LOGIN';
export const ERROR_LOGIN = 'ERROR_LOGIN';
export const LOADING_LOGIN = 'LOADING_LOGIN';
export const AUTH_USER = 'AUTH_USER';
export const GET_LOGO_URL = 'GET_LOGO_URL';
